export default __webpack_public_path__ + "static/media/ic-marker-valid.b3ec3e43.svg";